module.exports = __webpack_public_path__ + "img/02.ea24b54e.png";